<template>
  <div class="wrapper">
    <ul class="kabao" v-for="item in allCards" :key="item.carId">
      <li class="info">
        <div>
          <span>{{ item.patientname }}</span>
          <span>{{ item.sex }}</span>
          <span>{{ item.age }}岁</span>
          <span class="give" v-if="item.style == 1?true:false">当前选中</span>
        </div>
        <div>
          <span>就诊ID号</span>
          <span>{{ item.patientId }}</span>
        </div>
        <div>
          <span>身份证</span>
          <span>{{ item.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span>
        </div>
      </li>
      <li class="btns" v-if="item.style == 1?false:true">
        <van-button type="primary" size="mini" round @click="selbtn(item)" v-if="item.style == 1?false:true">选择</van-button>
      </li>
    </ul>
    <div class="yygh">
      <van-button @click="goguahao" type="info">前往挂号</van-button>
    </div>
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, delCard, setStyle } from "@/request/api.js";
import Judgment from "@/components/Judgment/Judgment.vue";
import { Dialog } from "vant";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      allCards: []
    };
  },
  async mounted() {
    this.handleQuery()
  },
  methods: {
    async handleQuery(){
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.allCards = res.data.obj;
      this.allCards.forEach(item => {
        if (item.style == 1) {
          sessionStorage.setItem("card", JSON.stringify(item));
        }
      });
    },
    // 就诊卡切换
    selbtn(it){
      let map = {
        carId: it.carId,
        openid: sessionStorage.getItem("openid")
      }
      Dialog.alert({
        message: "是否切换就诊卡",
        showCancelButton: "true"
      })
        .then(async () => {
          console.log(map)
          let res = await setStyle(map);
          if(res.data.message == "操作成功"){
            this.Toast.success('操作成功');
            this.handleQuery();
          } else {
            this.Toast.fail('操作失败');
          }
        })
        .catch(() => {});
    },
    goguahao(){
      this.$router.push("/hospitalRegister");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f7f7f9;
  .noneCard {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    margin-bottom: 40px;
    > img {
      width: 130px;
      margin: 100px 0px 20px;
    }
    > span {
      letter-spacing: 2px;
      font-size: 14px;
    }
  }
  .kabao {
    margin: 10px 10px 20px;
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    .info {
      border-bottom: 1px solid #eee;
      padding: 10px 10px 0px;
      position: relative;
      font-size: 14px;
      > div {
        margin-bottom: 10px;
        > span {
          margin-right: 10px;
        }
        .give {
          background: #399acd;
          padding: 1px 5px;
          color: #fff;
          border-radius: 2px;
        }
      }
      > img {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 28px;
      }
    }
    /deep/ .btns {
      padding: 10px;
      text-align: right;
      .van-button--danger {
        width: 60px;
        background: #ef7b48;
        border: #ef7b48;
      }
      .van-button--mini {
        width: 60px;
      }
    }
  }
  /deep/ .van-button--info {
    width: 355px;
    margin: 0px 10px;
    background: #399fd0;
  }
  .relation {
    display: block;
    text-align: center;
    margin-top: 20px;
    letter-spacing: 1px;
    color: #82cae3;
    font-size: 12px;
  }
  /deep/ .yygh{
    text-align: center;
    // background: rgb(83, 192, 255);
    color: rgb(255, 255, 255);
    .van-button{
      background: rgb(83, 192, 255);
      padding: 24px 0px;
      width: 355px;
      letter-spacing: 1px;
      font-size: 20px;
      border-color: rgb(62, 184, 255);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/selectVisitor.vue